module.exports = __webpack_public_path__ + "static/media/delete.d78ca60f.svg";